/**
 * The hb-setup-guide-streamlined directive
 *
 * This directive puts the setup guide. i made this directive so it will be easy to use it as a modal or as a page.
 * currently we are using it as a page.
 *
 * parameters:
 * closeHandler : Function. function to be fired in order to close the setup guide - if it's modal it's different,
 * className: String. css class name to be added to the top level of the setup guide,
 *
 */




(function () {
    'use strict';

    Directives.SetupGuideStreamlinedDirective = function SetupGuideStreamlinedDirective() {

        // @ngInject
        function SetupGuideStreamlinedDirectiveControllerConstructor(
            $scope, $injector, $timeout, $document, moment, AnalyticsService, UsersManager, CompaniesManager, 
            PopupMessageService, AppStates, _, WorkspaceFileService, EventService, $state, 
            OnboardingBotManager, JsSlicklightboxService, UserService, ModalService, OnboardingService, 
            SetupGuideService, DeviceService, $window, Drift) {
            this.constructor.$super.call(this, $scope, $injector);
            this._objectType = 'SetupGuideStreamlinedDirectiveController';

            this._ = _;
            this.AnalyticsService = AnalyticsService;
            this.CompaniesManager = CompaniesManager;
            this.PopupMessageService = PopupMessageService;
            this.AppStates = AppStates;
            this.WorkspaceFileService = WorkspaceFileService;
            this.EventService = EventService;
            this.moment = moment;
            this.$state = $state;
            this.$timeout = $timeout;
            this.OnboardingBotManager = OnboardingBotManager;
            this.JsSlicklightboxService = JsSlicklightboxService;
            this.UserService = UserService;
            this.ModalService = ModalService;
            this.OnboardingService = OnboardingService;
            this.SetupGuideService = SetupGuideService;
            this.DeviceService = DeviceService;
            this.$window = $window;
            this.Drift = Drift;

            this.googleCalendarProvider = null;
            this.subscriptionDiscountValue = 0;
            this.currUser  = UsersManager.getCurrUser();
            this.company = this.CompaniesManager.getCurrCompany();
            this.isCompanyOwner = this.currUser.isCompanyOwner();
            this.pageTitle = 'ONBOARDING.SETUP_GUIDE_STREAMLINED.HEADER._TITLE_';
            this.pageSubTitle = 'ONBOARDING.SETUP_GUIDE_STREAMLINED.HEADER._SUBTITLE_';
            this.showSubscribeNowButton = false;

            this.completedDonutString = String(SetupGuideService.completedDonut() * 100);

            this.AnalyticsService.trackPageView(
                this, 
                this.AnalyticsService.analytics_events.setup_guide,
                {
                    source: 'setup_guide_streamlined',
                    setup_guide_variant: this.SetupGuideService.setupGuideType
                }
            );

            this.firstNamePossessive = 'Your';
            if (this.currUser.first_name) {
                if (this.currUser.first_name.slice(-1) === 's') {
                    // Charles’ Setup Guide
                    this.firstNamePossessive = this.currUser.first_name + '’';
                }
                else {
                    // Jennifer’s Setup Guide
                    this.firstNamePossessive  = this.currUser.first_name + '’s';
                }
            }

            this.companyHasCustomLogo = !this.currUser.company.isDefaultCompanyIcon();

            this.completedPercentage = 0;
            this.referrer = '';
            this.galleryInitialized = false;
            this.lightboxContainer = '#demo-account-gallery--setup-guide-modal';
            this.demo_assets = [
                "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/01_pipeline.png",
                "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/02_workspace_activity.png",
                "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/03_workspace_files.png",
                "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/04_invoice.png",
                "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/05_agreements.png",
                "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/06_bookkeping.png",
                "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/07_workflows.png",
                "https://res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1517476087/onboarding/demo/08_tasks.png"
            ];

            this.headerItems = this._.where(this.SetupGuideService.steps, {listKey: "headerItems"});
            this.exploreItems = this._.where(this.SetupGuideService.steps, {listKey: "exploreItems"});
            this.customizeItems = this._.where(this.SetupGuideService.steps, {listKey: "customizeItems"});

            this.SetupGuideService.checkIfCompanyHasLogo();
            // Note to self: .completeStepByKey updates the UIPersistence
            this.SetupGuideService.completeStepByKey('companyInfo');

            this.isHomeSetupGuideStreamlinedVariation =
                this.SetupGuideService.setupGuideType === this.SetupGuideService.setupGuideVersionNames.v4;

            this.calcCompleted();

            const computeHeaderContent = () => {
                const isSubscribed = this.currUser.companyHasSubscription();
                const createProject = this._.find(this.headerItems, item => item.key === 'createProject');
                const becomeMember = this._.find(this.headerItems, item => item.key === 'becomeMember');

                let headerContent = createProject;
                if (createProject.isComplete && !becomeMember.isComplete) {
                    headerContent = becomeMember;
                }
                if (createProject.isComplete && becomeMember.isComplete && !isSubscribed) {
                    headerContent = becomeMember;
                }
                return headerContent;
            };

            this.headerItem = computeHeaderContent();

            this.shouldShowHeaderItems = this._.every(this.exploreItems, item => item.isComplete);
            this.nextIncompleteItem = this._.find(this.exploreItems, item => !item.isComplete);
            if (this.nextIncompleteItem) {
                this.nextIncompleteItem.isNext = true;
                this.openItemByKey(this.nextIncompleteItem.key);
            }

            this.toggleDrift(false);

            this.closeOnEscape = ($event) => {
                // This closes the generic video modal
                // AND the setup guide as if it were a modal.
                if ($event.keyCode === 27) {
                    let videoModal = 
                        document.querySelector('.setup-guide-streamlined__video-modal');
                    
                    // [click: setup guide escape]
                    this.AnalyticsService.trackClick(
                        this,
                        this.AnalyticsService.analytics_events.setup_guide + ' escape',
                        { source: 'setup_guide_streamlined',
                          video_state: Boolean(videoModal) ? 'open' : 'closed' });

                    if (videoModal) {
                        videoModal.parentNode.removeChild(videoModal);
                    } else {
                        this.close();
                    }
                }
            }
            $timeout($document.keydown(this.closeOnEscape), 500);

            $scope.$on('$destroy', function () {
                $document.off('keydown');
            }.bind(this));

        }


        var SetupGuideStreamlinedDirectiveController = Class(Controllers.BaseController, {

            constructor: SetupGuideStreamlinedDirectiveControllerConstructor,

            toggleDrift: function toggleDrift(isShow) {
                if (isShow) {
                    this.Drift.show();
                } else {
                    this.Drift.hide();
                }
            },

            showProgressBar: function showProgressBar() {
                return (this.completedPercentage < 100);
            },

            calcCompleted: function calcCompleted() {
                this.countUp(this.completedPercentage, this.SetupGuideService.setupGuideStats.completion);
                this.completedPercentage = this.SetupGuideService.setupGuideStats.completion;
                this._handleChangeTitleText();
            },

            _handleChangeTitleText: function _handleChangeTitleText() {
                switch (this.completedPercentage) {
                    case 99:
                        if (this.isCompanyOwner && this.shouldShowTrialText()) {
                            this._setTitleForLastStep()
                        }
                        break;

                    case 100:
                        this._setTitleForCompletion();
                        break;
                }
            },

            _setTitleForLastStep: function _setTitleForLastStep() {
                this.pageTitle    = 'ONBOARDING.SETUP_GUIDE_MODAL.HEADER._TITLE_LAST_STEP_';
                this.pageSubTitle = 'ONBOARDING.SETUP_GUIDE_MODAL.HEADER._SUBTITLE_LAST_STEP_';
                this.showSubscribeNowButton = true;
            },

            _setTitleForCompletion: function _setTitleForLastStep() {
                // this.pageTitle    = '100%';
                this.pageSubTitle = 'ONBOARDING.SETUP_GUIDE_MODAL.HEADER._ALL_DONE_';
                this.showSubscribeNowButton = false;
            },

            countUp: function countUp(startValue, endValue) {
                $('.js-setup-guide-modal-progress-count').each(function() {
                    $(this).prop('counter', startValue).animate({
                        counter: endValue
                    }, {
                        duration: 2000,
                        easing: 'swing',
                        step: function(now) {
                            $(this).text(Math.ceil(now));
                        }
                    });
                });
            },

            close: function close() {
                this.toggleDrift(true);
                if (this.closeHandler && angular.isFunction(this.closeHandler)) {
                    this.closeHandler();
                }
            },

            showMobileWarningMessage: function showMobileWarningMessage() {
                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info, 'ONBOARDING.SETUP_GUIDE._MOBILE_WARNING_MESSAGE_');
            },

            openItemByKey: function openItemByKey(key) {
                const openIfMatchesKey = item => {
                    if (item.key === key) {
                        item.isOpen = true;
                    }
                    return item;
                }
                this.exploreItems = this.exploreItems.map(openIfMatchesKey);
            },

            onStepClick: function onStepClick(step, position) {

                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.toggle_setup_guide_modal_task, {
                    setup_task: step.key,
                    source: 'setup_guide_streamlined',
                    setup_guide_variant: this.SetupGuideService.setupGuideType
                });

                const closeStep = step => {
                    step.isOpen = false;
                    return step;
                }
                const stepWasNotOpen = !step.isOpen;
                this.exploreItems = this.exploreItems.map(closeStep);
                if (stepWasNotOpen) {
                    step.isOpen = true;
                }
            },

            onStepCTAClick: function onStepCTAClick(event, step, position) {
                // Don't let the event percolate up to the onStepClick()
                // and visually close the step while processing
                event.stopPropagation();

                // special handle for mobile
                if (this.DeviceService.checkIfMobileSize() && step.disableOnMobile) {
                    // block steps o mobile that are not relevant
                    this.showMobileWarningMessage();
                    return;
                }

                if (step.closeSetupGuideOnClick) {
                    this.toggleDrift(true);
                }

                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.setup_guide_modal_task, {
                    type: step.listKey === 'exploreItems' ? 'explore' : 'customize',
                    setup_task: step.key,
                    completion: this.completedPercentage,
                    is_completed: step.isComplete,
                    source: 'setup_guide_streamlined',
                    position: position,
                    setup_guide_variant: this.SetupGuideService.setupGuideType
                });

                if (!step.isComplete && !step.disableAutoCompleteTask) {
                    this.$timeout(() => {
                        this.SetupGuideService.completeStep(step);
                        this.calcCompleted();
                    },1000);
                }

                if (step.clickHandler && angular.isFunction(step.clickHandler)) {
                    step.clickHandler();
                }

            },

            onStepSecondaryCTAClick: function onStepSecondaryCTAClick(event, step, position) {
                // Don't let the event percolate up to the onStepClick()
                // and visually close the step while processing
                event.stopPropagation();

                if (step.secondaryClickHandler && angular.isFunction(step.secondaryClickHandler)) {
                    step.secondaryClickHandler();
                }
            },

            shouldShowTrialText: function shouldShowTrialText() {
                return this.OnboardingService.showOnboardingBar();
            },

            getDaysTillTrialEnds: function getDaysTillTrialEnds() {
                return this.currUser && this.currUser.nTillTrialEnds();
            },

            upgradeNow: function onUpgradeNow() {
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.setup_guide_modal_subscription, {
                    unique: 'membership page',
                    source: 'setup_guide_streamlined',
                    trial_days_left: this.getDaysTillTrialEnds(),
                    type: this.getUserType(),
                    setup_guide_variant: this.SetupGuideService.setupGuideType
                });

                this.$state.go(this.AppStates.root_core_navigation_settings_companySettings_subscription);
            },

            isInTrial: function isInTrial() {
                return this.getDaysTillTrialEnds() > 0;
            },

            getUserType: function getUserType() {
                var userType = "x-trial";

                if (this.currUser.isReferralTrialer()) {
                    userType = "referral";
                } else if (this.isInTrial()) {
                    userType = "trial";
                }

                return userType;
            },

            shareasaleGetCookie: function shareasaleGetCookie(e) {
                return this.SetupGuideService.shareasaleGetCookie(e);
            },

            showShareasalePixel: function showShareasalePixel() {
                return this.SetupGuideService.showShareasalePixel(this.currUser);
            },

    });

        return {
            scope: {
                closeHandler : '&',
                className: '@'
            },
            templateUrl: 'angular/app/modules/common/ui_components/dark_setup_guide/setup_guide_streamlined_directive_template.html',
            controller: SetupGuideStreamlinedDirectiveController,
            controllerAs: 'setupGuideStreamlinedVm',
            bindToController: true
        };
    };


}());